// @flow
import PrimaryPalette from '../../colors';

const Theme = {
  default: {
    backgroundColor: PrimaryPalette.darkerGrey,
    switchColor: PrimaryPalette.white,
    labelColor: PrimaryPalette.mediumEvergreen,
  },
  checked: {
    backgroundColor: PrimaryPalette.darkGreen,
    switchColor: PrimaryPalette.white,
    labelColor: PrimaryPalette.mediumEvergreen,
  },
  disabled: {
    backgroundColor: PrimaryPalette.darkGrey,
    switchColor: PrimaryPalette.lightGrey,
    labelColor: PrimaryPalette.darkGrey,
  },
  active: {
    // 13% opacity https://gist.github.com/lopspower/03fb1cc0ac9f32ef38f4
    dropShadowColor: PrimaryPalette.mediumEvergreen + '21',
  },
  iconColor: PrimaryPalette.white,
};

export default Theme;
